import { gql } from '@apollo/client'
import { sortReplies } from '@btime/helpers'
import React from 'react'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import { useServiceOrder } from './ServiceOrderLoader'

const Context = React.createContext([])
const { Provider } = Context
export const useServiceOrderCertifyState = () => React.useContext(Context)
export const useServiceOrderCertify = () => useServiceOrderCertifyState()?.serviceOrders
export const useCertifyReplies = () => {
  const replies = useServiceOrderCertify()?.replies || []
  return sortReplies(replies)
}

const QUERY = gql`
  query ServiceOrder($userIds: [Int]) {
    serviceOrders(
      filter: { userIds: $userIds, checklistIds: [344], statusNames: ["completed", "approved"], ignoreSegments: true }
      sort: { field: END_DATE, type: DESC }
      limit: 1
    ) {
      id
      yearlyId
      startDate
      endDate
      deleted
      insertedAt
      updatedAt
      fieldValues {
        id
        value
        fieldId
        field {
          id
          name
          type
        }
      }
      scheduling
      customerCode
      internalCode
      invoice
      description
      documents {
        id
        src
        type
        description
      }
      statusReason {
        id
        typeId
        name
        description
        document {
          id
          src
        }
      }
      events {
        id
        status {
          id
          name
        }
        eventDate
        address
        reason {
          id
          name
        }
        document {
          id
          type
          src
        }
        description
      }
      status {
        id
        name
      }
      user {
        id
        name
      }
      placeId
      place {
        id
        name
        resume
        fieldValues {
          id
          value
          field {
            id
            name
            type
          }
        }
      }
      company {
        id
        name
        nationalRegistration
      }
      checklist {
        id
        name
      }
      replies {
        id
        value
        notes
        questionId
        insertedAt
        isNonCompliance
        documents {
          id
          src
          type
          description
        }
        question {
          id
          name
          parentReference
          reference
          ordination
          categoryOrdination
          nonComplianceConditions
          type {
            id
            name
          }
          category {
            id
            name
          }
        }
      }
    }
  }
`

const ServiceOrderLoaderCertify = ({ children }) => {
  const serviceOrder = useServiceOrder()
  const btimeId = 1

  const { data, ...state } = useQuery(QUERY, {
    variables: { userIds: [serviceOrder.user.id, btimeId] },
    client: serviceOrdersClient
  })

  return (
    <StatePresenter {...state} empty={!data?.serviceOrders}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ServiceOrderLoaderCertify
